import { getRequest } from "./ApiService";

export function getDeclarationList(){
    return getRequest('declarationList')
}
